import { useState, useEffect } from 'react';
import { subscriptionService, Subscription } from '../services/subscriptionService';

export const useSubscriptionStatus = () => {
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('🔍 Verificando suscripción del usuario...');
        const subscription = await subscriptionService.getUserSubscription();
        console.log('📋 Suscripciones obtenidas:', subscription);
        
        const activeOrTrialSubscription = subscription?.status === 'active' || subscription?.status === 'trialing';
        console.log('✅ Suscripción activa o en prueba encontrada:', activeOrTrialSubscription);
        
        setHasActiveSubscription(!!activeOrTrialSubscription);
        setSubscription(subscription || null);
      } catch (err) {
        console.error('❌ Error checking subscription:', err);
        setError('Error al verificar suscripción');
        setHasActiveSubscription(false);
        setSubscription(null);
      } finally {
        setLoading(false);
      }
    };

    checkSubscription();
  }, []);

  const refreshSubscription = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const subscription = await subscriptionService.getUserSubscription();
      const activeOrTrialSubscription = subscription?.status === 'active' || subscription?.status === 'trialing';
      
      setHasActiveSubscription(!!activeOrTrialSubscription);
      setSubscription(subscription || null);
    } catch (err) {
      console.error('Error refreshing subscription:', err);
      setError('Error al actualizar suscripción');
    } finally {
      setLoading(false);
    }
  };

  return { 
    hasActiveSubscription, 
    subscription, 
    loading, 
    error, 
    refreshSubscription 
  };
}; 